import { onAuthStateChanged } from 'firebase/auth'
import React, { useEffect, useState } from 'react'
import './Youtube.css'
import { auth } from '../firebase'
import { signOut } from 'firebase/auth'
import './Youtube.css'
import { Link, useSearchParams } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header'
import { notify } from './utility'
import Footer from './Footer'
import { login } from './utility'

function Youtube({ data, server }) {
    // console.log(data.isSubscribed)
    // const subscribed = data.isSubscribed
    const [subscribed, setSubscribed] = useState(null)
    const [userAuth, setUserAuth] = useState(undefined)
    const [load, setLoad] = useState(false)
    const [channelId, setChannelId] = useState('')
    const [userId, setUserId] = useState('')
    const [genLink, setGenLink] = useState('')
    const [userData, setUserData] = useState([])
    const [query] = useSearchParams()


    let session_id = query.get('session_id')

    useEffect(() => {
        onAuthStateChanged(auth, user => {
            if (user) {
                console.log('data')
                fetch(server + '/user/' + user.email, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json()).then(data => setUserData(data))
                setUserAuth(user)
                setLoad(true)

            } else {
                setUserAuth(undefined)
                setLoad(true)

            }
        })


        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        (function getData() {
            if (userData.generatedLink !== "" && userData.generatedLink !== undefined) {
                notify('info', "You have already generated a link, Check profile or FAQ")
            }
        })()
        async function getSession() {
            if (session_id !== null) {

                // check if the session is expired 
                const data = await fetch(server + '/youtube?session_id=' + session_id).then(res => res.json())


                // if session is not expired then call this 👇
                fetch(server + '/updateuser', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: userAuth.email,
                        customerId: data.customer,
                        startTrial: data.subscription.trial_start,
                        endTrial: data.subscription.trial_end,
                        daysLeft: data.subscription.billing_cycle_anchor,
                        dateOfSub: data.subscription.created,
                        sessionId: session_id
                    })
                }).then(res => res.json()).then(data => {
                    setSubscribed(data.isSubscribed);
                    setLoad(true)
                })

                // use the customer id from above fetch to get subscription details
                // save the customer id to db

            }
        }

        // if session is expired then dont call
        if (userData.customerId === "" && userData.sessionId === "") {
            setLoad(true)
            getSession()
            console.log('get session')
        }
        console.log(userData)
        // eslint-disable-next-line
    }, [userData])

    const logout = () => {
        return signOut(auth)
    }

    // console.log(userAuth)
    const checkYt = async (e) => {
        e.preventDefault()
        if (genLink || userData.generatedLink !== "") {
            notify('error', 'You have already generated a link, check profile')
        } else {
            if (channelId && userId && channelId.slice(2,) === userId) {
                // let videoId = await result.items[0].id;

                let result = await fetch(`https://youtube.googleapis.com/youtube/v3/channels?part=snippet&id=${channelId}&key=${process.env.REACT_APP_YT_API_KEY}`).then(res => res.json())

                if (!result.error && result.items) {
                    fetch(server + '/url', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            channelId,
                            "email": userAuth.email,
                        })
                    }).then(res => res.json()).then(data => {
                        setGenLink(data.generatedLink)
                        notify('success', "Link generated successfully")
                    })
                } else {
                    alert('ERROR: this is not a youtube channel')
                }
            } else {
                alert('Please provide correct information')
            }
        }



        // sanya id = UCEl-w9TMidnnm8X3mQaSF6g
        // nimish id = UC3CTmybHAhwECpq5FCtJeiQ

    }

    const copyLink = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(genLink)
        notify('success', 'Link copied successfully')
    }

    const loginUser = () => login(userAuth)

    return (
        <>
            <div>

                {load === true ? (<>
                    <Header user={userAuth} logout={logout} login={loginUser} />
                    {userAuth && (subscribed || userData.isSubscribed) ? <section className="subscribed">
                        <ToastContainer />
                        <div className="span_links" >
                            <Link to="/faq" title="Frequently Asked Questions">
                                FAQ?
                            </Link><br />
                            <Link to="/guide" title="Guide for Tubelink">
                                Guide
                            </Link>
                        </div>
                        <div className="plan_name">BASIC PLAN</div>
                        <div className="channel_id_form">
                            <form>
                                <label for="input_id">Your youtube channel ID</label>
                                <input type="text" name="input_id" id="input_id" value={channelId} onChange={(e) => setChannelId(e.target.value)} />
                                <br />
                                <label for="input_id">Your youtube user ID</label>
                                <input type="text" name="input_id" id="input_id" value={userId} onChange={(e) => setUserId(e.target.value)} />
                                <button className={(channelId && userId.length > 5) ? 'generate' : 'generate disabled_color'} disabled={(channelId && userId) && false} onClick={checkYt}>GENERATE LINK</button>
                            </form>
                            <form>
                                <label>Share this link 👇</label>
                                <input placeholder='this is a box for generated link, copy it' value={genLink} />
                                <button className={genLink ? 'copy' : ' copy disabled_color'} onClick={copyLink} disabled={genLink === "" && true}>COPY LINK</button>

                            </form>
                        </div>
                    </section> : userAuth === undefined ? <section className="not_logged_in"><div>
                        Please Login
                    </div>
                        <div>Go to&nbsp;
                            <Link to="/">Homepage</Link>
                        </div></section> : <section className="not_subscribed">
                        Please Subscribe to continue
                        <Link to="/pricing">Pricing</Link>
                    </section>}
                </>) : 'loading'}
            </div>
            <Footer user={userAuth} logout={logout} login={loginUser} />
        </>
    )
}

export default Youtube